import { inject, Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { concatMap, map, toArray } from 'rxjs/operators';
import { WebhookService } from './webhook.service';

interface DGRebateResyncResponse {
  data?: {
    error?: unknown;
    Error?: unknown;
    message?: string;
    Message?: string;
    manualResync?: {
      isManualResyncEligible?: boolean;
      IsManualResyncEligible?: boolean;
    };
    ManualResync?: {
      isManualResyncEligible?: boolean;
      IsManualResyncEligible?: boolean;
    };
  };
}

@Injectable({
  providedIn: 'root',
})
export class DGRebateResyncService {
  private readonly webhookId = 'DGRebateAutoResyncProcessor';
  private readonly webhookService = inject(WebhookService);

  resyncInitialApplication(
    sourceApplicationIds: string[],
    rebateApplicationId: string
  ): Observable<void> {
    const uniqueSourceApplicationIds = sourceApplicationIds.filter(
      (applicationId, index, applicationIds) =>
        !!applicationId && applicationIds.indexOf(applicationId) === index
    );

    return from(uniqueSourceApplicationIds).pipe(
      concatMap((sourceApplicationId) =>
        this.webhookService
          .postWebhook(this.webhookId, {
            applicationId: sourceApplicationId,
            sourceApplicationId,
            rebateApplicationId,
            requestSource: 'ManualResync',
            isManualResync: true,
            dryRun: false,
          })
          .pipe(concatMap((response) => this.validateResponse(response)))
      ),
      toArray(),
      map(() => undefined)
    );
  }

  private validateResponse(response: DGRebateResyncResponse): Observable<void> {
    const functionResponse = response?.data;
    const functionError = functionResponse?.error ?? functionResponse?.Error;
    const functionMessage =
      functionResponse?.message ?? functionResponse?.Message;
    const manualResync =
      functionResponse?.manualResync ?? functionResponse?.ManualResync;
    const manualResyncEligible =
      manualResync?.isManualResyncEligible ??
      manualResync?.IsManualResyncEligible;

    if (!functionMessage || functionError || manualResyncEligible === false) {
      return throwError(() => new Error('DG Rebate resync failed'));
    }

    return from([undefined]);
  }
}
